import { z } from "zod";

const seedCountField = z.number().int().nonnegative();

export const DemoPersonaSeedSummarySchema = z.object({
  total: seedCountField,
  byArchetype: z.object({
    startupVc: seedCountField,
    academicAlumni: seedCountField,
    industryCorporate: seedCountField,
    intimateCommunity: seedCountField,
  }),
});

export type DemoPersonaSeedSummary = z.infer<
  typeof DemoPersonaSeedSummarySchema
>;
